import { ReactElement, useMemo } from 'react';
import { handlePreventDefault, isFilterValuePresent } from '@helper/utils';
import { useFilterStore } from '@store/filter';
import { ISiteSummarySearchProps } from '.';
import { useSsSiteSummaryListingStore } from '@store/ssSiteSummaryFilterStore';

export const SSSummerySearch = (props: ISiteSummarySearchProps): ReactElement => {
	const { setSiteSummaryFilterCallback } = props;
	const { search, updateSearch } = useFilterStore();
	const { allSSSiteSummaryFilter } = useSsSiteSummaryListingStore();

	const isFilterActive: boolean = useMemo(() => {
		return Object.values(allSSSiteSummaryFilter).some(isFilterValuePresent);
	}, [allSSSiteSummaryFilter]);
	return (
		<div className="filter-section">
			<div className="search-filter-wrapper">
				<div className="search-with-filter">
					<div className="search">
						<form onSubmit={handlePreventDefault}>
							<div className="search-row">
								<div className="input-col">
									<label htmlFor="search-top" className="hide">
										search
									</label>
									<input
										value={search}
										onChange={(e) => updateSearch(e.target.value)}
										type="text"
										name="search"
										id="search-top"
										placeholder="Search site name"
										className="search-bar"
									/>
								</div>

								<button className="search-button" aria-label="search user" onClick={handlePreventDefault}>
									<span className="icon-search"></span>
								</button>
							</div>
						</form>
					</div>

					<div className="filters">
						<button
							className={`filter-button ${isFilterActive && 'active'}`}
							aria-label="filter"
							id="filter-contractor"
							onClick={setSiteSummaryFilterCallback}
						>
							<span className="icon-filter"></span>
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};
